import cx from 'classnames';

// Types
import { IframeProps } from './Iframe.types';

// Styles
import styles from './iframe.scss';

const Iframe = ({ allow, fullScreen = false, id, name, onLoad, src }: IframeProps) => (
  <iframe
    allow={allow}
    className={cx(styles.iframe, { [styles.fullScreen]: fullScreen })}
    id={id}
    name={name}
    onLoad={onLoad}
    src={src}
  />
);

export default Iframe;
